import { faStar } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { JoonColorExpanded } from "@joonapp/web-shared"

const FiveStars = ({ size = 16 }: { size?: number }) => {
  return (
    <div className="flex flex-row items-center">
      {[...new Array(5)].map((_, index) => (
        <FontAwesomeIcon
          key={index}
          icon={faStar}
          color={JoonColorExpanded.yellow400}
          fontSize={size}
        />
      ))}
    </div>
  )
}

export default FiveStars
